import { EventEmitter } from 'events'
import freqTable from 'Dummy/freqTable'

class Sequencer extends EventEmitter
  constructor: (audioContext, tempo, sequence) ->
    super()
    @audioContext = audioContext
    @secondsPerBeat = (60 / tempo)
    @sequence = sequence
    @active = true
    @timer = undefined

    @lookahead = 25.0
    @scheduleAheadTime = 0.1
    @nextNoteTime = @audioContext.currentTime
    @currentStep = 0

  setTempo: (tempo) ->
    @secondsPerBeat = (60 / tempo)

  setSequence: (sequence) ->
    @sequence = sequence

  scheduleStep: (step, time) ->
    [freq, length] = step.split('n')
    freq = freqTable[freq]
    length = (1 / length or 1) * @secondsPerBeat
    if freq
      @emit('tick', { freq, length, time })

  nextStep: ->
    @nextNoteTime += @secondsPerBeat

    @currentStep++
    if @currentStep is @sequence.length
      @currentStep = 0

  scheduler: ->
    while @nextNoteTime < @audioContext.currentTime + @scheduleAheadTime
      @scheduleStep(@sequence[@currentStep], @nextNoteTime) if @active
      @nextStep()

    @timer = setTimeout(=>
      @scheduler()
    , @lookahead)

export default Sequencer
